export default __webpack_public_path__ + "static/media/aadesh_cabs.59d7d0f7.png";